import React, { useCallback, useEffect, useState } from 'react';
import { Box, Button, SvgIcon, Typography } from '@mui/material';
import { useNavigate } from 'react-router';
import { Stack } from '@mui/system';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useSelector } from 'react-redux';
import EditIcon from '@mui/icons-material/Edit';
import { Link } from 'react-router-dom';
import { getAccessToken } from 'src/routes/AuthContext';

type Props = {};

function ScreeningPreviewDocument(props: Props) {
  const navigate = useNavigate();

  const [iframeRef, setIframeRef] = useState<any | null>(null);

  const updateIFrameRef = useCallback((node: any) => {
    setIframeRef(node);
  }, []);

  useEffect(() => {
    const iframeElement = iframeRef;

    if (iframeElement) {
      const interval = setInterval(async () => {
        const response = await getAccessToken();
      }, 15000);

      return () => {
        clearInterval(interval);
      };
    }
  }, [iframeRef]);

  const previeWScreeningData = useSelector(
    (state: any) => state.getScreeningReducer?.previewScreeningData
  );

  const handleEditForm = () => {
    navigate('/patients/patient-details/screening/view-edit-document');
  };

  return (
    <>
      <Stack
        gap="1.5rem"
        sx={{ padding: '0 4rem' }}
      >
        <Button
          sx={{
            justifyContent: 'flex-start',
            color: '#111927',
            width: 'max-content',
            padding: '0px',
          }}
          startIcon={
            <SvgIcon>
              <ArrowBackIcon sx={{ color: '#6C737F' }} />
            </SvgIcon>
          }
        >
          <Link
            style={{ color: '#111927' }}
            to={'/patients/patient-details/screening'}
          >
            <Typography variant="subtitle1">Back to Screening List</Typography>
          </Link>
        </Button>
        <Stack
          flexDirection="row"
          gap="1rem"
          justifyContent="space-between"
          alignItems="center"
        >
          <Typography variant="h5">
            {/* Preview Document - {location?.state?.document?.documentType} */}
            Preview Document
          </Typography>
          <Button
            variant="text"
            startIcon={<EditIcon />}
            // onClick={() =>
            //   navigate(`${patients}/${patientDetails}${episodeOfCare}${editEpisodeOfCare}`, {
            //     state,
            //   })
            // }

            onClick={handleEditForm}
          >
            Edit Details
          </Button>
        </Stack>
      </Stack>
      <Box
        sx={{ height: '100%' }}
        p={3}
      >
        <iframe
          src={`${previeWScreeningData?.pdfUrl}`}
          ref={updateIFrameRef}
          width={'100%'}
          height={'100%'}
          style={{ border: 'none' }}
          title="this is preview document"
        />
      </Box>
    </>
  );
}

export default ScreeningPreviewDocument;
